import { fetchAndActivate, getValue } from "firebase/remote-config";
import { remoteConfig } from "@/plugins/firebase";

const TIMEOUT = 100;

export const checkMaintenanceMode = async () => {
  if (process.env.NODE_ENV === "development") {
    return false;
  }

  await Promise.race([fetchAndActivate(remoteConfig), wait(TIMEOUT)]).catch(console.error);

  return getValue(remoteConfig, "maintenanceMode").asBoolean();
};

export const checkCsvImportMaintenanceMode = async () => {
  if (process.env.NODE_ENV === "development") {
    return false;
  }

  await Promise.race([fetchAndActivate(remoteConfig), wait(TIMEOUT)]).catch(console.error);

  return getValue(remoteConfig, "csvImportMaintenanceMode").asBoolean();
};

const wait = (time?: number): Promise<void> =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, time ?? 1000);
  });
